import React from "react";
var __jsx = React.createElement;
import { Icon } from "@syarahtech/ui";
var CartIcon = function CartIcon() {
  return /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--add-shopping-cart-rounded",
    className: "text-primary-new",
    width: 5,
    height: 5
  });
};
export default CartIcon;